module.exports = __webpack_public_path__ + "static/media/player-hex.6cef2cc6.svg";